import { CampaignAttentionReason } from '@aslanpay/portal-common-lib';

/**
 * What each reason a campaign wants attention means, in words somebody can act on.
 * <p>
 * The service says what is wrong; this says what to do about it. A reason nobody has written words for falls
 * back to nothing rather than showing a constant, so a reason added later reads as silence and not as noise.
 */
const ATTENTION_REASONS: Record<CampaignAttentionReason, string> = {
  NO_CAMPAIGN_MANAGER: 'Nobody can decide it — appoint a campaign manager.',
  NO_NOMINATIONS: 'Nominations closed with none made, so there is nobody to choose between.',
  DECISION_OVERDUE: 'The review has run past its close with no winner recorded.',
  ANNOUNCEMENT_RETRYABLE: 'The announcement did not complete. Announcing again could work.',
  ANNOUNCEMENT_BLOCKED:
    'The announcement cannot complete as it stands — the winner has usually left.',
  NO_FUNDING_POT: 'It pays an award and has no funding pot, so no winner can be chosen.',
  POT_CANNOT_COVER_AWARD: 'The funding pot cannot cover the award, so the announcement will fail.',
};

/** The reasons a campaign wants attention, said in full. Empty where nothing is wrong. */
export const describeAttention = (reasons?: CampaignAttentionReason[]) =>
  (reasons ?? []).map((reason) => ATTENTION_REASONS[reason]).filter(Boolean);
